export default "__VITE_ASSET__D3cGMgE4__"